export default __webpack_public_path__ + "static/media/MaterialIconsRound-Regular.b882547c.ttf";